var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilOtzivi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 899,
    viewBox: "0 0 415 899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0558 30.8952C49.477 31.6941 48.6591 32.0936 47.6021 32.0936C46.5451 32.0936 45.723 31.6941 45.1358 30.8952C44.557 30.0881 44.2676 29.012 44.2676 27.6669C44.2676 26.3218 44.557 25.2498 45.1358 24.4508C45.723 23.6438 46.5451 23.2402 47.6021 23.2402C48.6591 23.2402 49.477 23.6438 50.0558 24.4508C50.643 25.2498 50.9366 26.3218 50.9366 27.6669C50.9366 29.012 50.643 30.0881 50.0558 30.8952ZM45.7901 30.3205C46.2263 30.9482 46.8303 31.262 47.6021 31.262C48.3739 31.262 48.9737 30.9482 49.4015 30.3205C49.8377 29.6927 50.0558 28.8082 50.0558 27.6669C50.0558 26.5256 49.8377 25.6411 49.4015 25.0133C48.9737 24.3856 48.3739 24.0718 47.6021 24.0718C46.8303 24.0718 46.2263 24.3856 45.7901 25.0133C45.3623 25.6411 45.1484 26.5256 45.1484 27.6669C45.1484 28.8082 45.3623 29.6927 45.7901 30.3205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8559 26.065C57.8559 26.709 57.6755 27.2797 57.3148 27.777L54.4333 31.9468H53.4392L55.6035 28.8164C55.377 28.8653 55.1421 28.8897 54.8988 28.8897C54.0348 28.8897 53.3259 28.6289 52.7723 28.1071C52.2186 27.5772 51.9418 26.8965 51.9418 26.065C51.9418 25.2335 52.2186 24.5568 52.7723 24.0351C53.3259 23.5052 54.0348 23.2402 54.8988 23.2402C55.7629 23.2402 56.4717 23.5052 57.0254 24.0351C57.579 24.5568 57.8559 25.2335 57.8559 26.065ZM53.3889 24.622C53.0114 24.9889 52.8226 25.4699 52.8226 26.065C52.8226 26.6601 53.0114 27.1411 53.3889 27.5079C53.7747 27.8748 54.2781 28.0582 54.8988 28.0582C55.5196 28.0582 56.0187 27.8748 56.3962 27.5079C56.7821 27.1411 56.9751 26.6601 56.9751 26.065C56.9751 25.4699 56.7821 24.9889 56.3962 24.622C56.0187 24.2552 55.5196 24.0718 54.8988 24.0718C54.2781 24.0718 53.7747 24.2552 53.3889 24.622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1746 26.8598C60.0404 26.9903 59.8768 27.0555 59.6839 27.0555C59.4909 27.0555 59.3273 26.9903 59.1931 26.8598C59.0589 26.7294 58.9918 26.5704 58.9918 26.3829C58.9918 26.1954 59.0589 26.0365 59.1931 25.906C59.3273 25.7756 59.4909 25.7104 59.6839 25.7104C59.8768 25.7104 60.0404 25.7756 60.1746 25.906C60.3088 26.0365 60.3759 26.1954 60.3759 26.3829C60.3759 26.5704 60.3088 26.7294 60.1746 26.8598ZM60.1746 31.8735C60.0404 32.0039 59.8768 32.0691 59.6839 32.0691C59.4909 32.0691 59.3273 32.0039 59.1931 31.8735C59.0589 31.743 58.9918 31.5841 58.9918 31.3966C58.9918 31.209 59.0589 31.0501 59.1931 30.9196C59.3273 30.7892 59.4909 30.724 59.6839 30.724C59.8768 30.724 60.0404 30.7892 60.1746 30.9196C60.3088 31.0501 60.3759 31.209 60.3759 31.3966C60.3759 31.5841 60.3088 31.743 60.1746 31.8735Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5542 30.8952C66.9754 31.6941 66.1575 32.0936 65.1005 32.0936C64.0435 32.0936 63.2214 31.6941 62.6342 30.8952C62.0554 30.0881 61.766 29.012 61.766 27.6669C61.766 26.3218 62.0554 25.2498 62.6342 24.4508C63.2214 23.6438 64.0435 23.2402 65.1005 23.2402C66.1575 23.2402 66.9754 23.6438 67.5542 24.4508C68.1414 25.2498 68.435 26.3218 68.435 27.6669C68.435 29.012 68.1414 30.0881 67.5542 30.8952ZM63.2885 30.3205C63.7247 30.9482 64.3287 31.262 65.1005 31.262C65.8723 31.262 66.4721 30.9482 66.8999 30.3205C67.3361 29.6927 67.5542 28.8082 67.5542 27.6669C67.5542 26.5256 67.3361 25.6411 66.8999 25.0133C66.4721 24.3856 65.8723 24.0718 65.1005 24.0718C64.3287 24.0718 63.7247 24.3856 63.2885 25.0133C62.8607 25.6411 62.6468 26.5256 62.6468 27.6669C62.6468 28.8082 62.8607 29.6927 63.2885 30.3205Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4801 30.8952C74.9013 31.6941 74.0834 32.0936 73.0264 32.0936C71.9694 32.0936 71.1473 31.6941 70.5601 30.8952C69.9813 30.0881 69.6919 29.012 69.6919 27.6669C69.6919 26.3218 69.9813 25.2498 70.5601 24.4508C71.1473 23.6438 71.9694 23.2402 73.0264 23.2402C74.0834 23.2402 74.9013 23.6438 75.4801 24.4508C76.0673 25.2498 76.3609 26.3218 76.3609 27.6669C76.3609 29.012 76.0673 30.0881 75.4801 30.8952ZM71.2144 30.3205C71.6506 30.9482 72.2546 31.262 73.0264 31.262C73.7982 31.262 74.3979 30.9482 74.8258 30.3205C75.262 29.6927 75.4801 28.8082 75.4801 27.6669C75.4801 26.5256 75.262 25.6411 74.8258 25.0133C74.3979 24.3856 73.7982 24.0718 73.0264 24.0718C72.2546 24.0718 71.6506 24.3856 71.2144 25.0133C70.7866 25.6411 70.5727 26.5256 70.5727 27.6669C70.5727 28.8082 70.7866 29.6927 71.2144 30.3205Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 413,
    height: 896.613,
    rx: 49,
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.346 1H306.652V14.2667C306.652 30.2829 293.669 43.2667 277.652 43.2667H137.346C121.329 43.2667 108.346 30.2829 108.346 14.2667V1Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249 22.1338H166",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M267.813 863.2H148.293",
    stroke: "#141515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 354.633,
    y: 23.7393,
    width: 24.4533,
    height: 8.96,
    rx: 1.5,
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 356.346,
    y: 25.4521,
    width: 9.96,
    height: 5.53333,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 1.10667,
    height: 5.53333,
    rx: 0.553333,
    transform: "matrix(-1 0 0 1 381.799 25.4521)",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 343.566,
    y1: 23.7393,
    x2: 343.566,
    y2: 32.6993,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 340.248,
    y1: 24.8457,
    x2: 340.248,
    y2: 32.699,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 336.928,
    y1: 25.9521,
    x2: 336.928,
    y2: 32.6988,
    stroke: "white",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 333.607,
    y1: 28.166,
    x2: 333.607,
    y2: 32.6993,
    stroke: "white",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 330.287,
    y1: 30.3789,
    x2: 330.287,
    y2: 32.6989,
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilOtzivi);
export default __webpack_public_path__ + "static/media/mobilOtzivi.5f7f17802035d673d433a94886b30aaf.svg";
export { ForwardRef as ReactComponent };